import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export interface AgentTool {
  id: number;
  name: string;
}

export interface AgentDocument {
  id: number;
  filename: string;
  content_type: string;
  byte_size: number;
  ocr_status: string;
  thumbnail_url: string | null;
}

export interface Agent {
  id: number;
  label: string;
  user_facing_question: string | null;
  system_prompt: string | null;
  profile_class: string | null;
  slug: string | null;
  icon: string | null;
  tool_ids: number[];
  tools: AgentTool[];
  document_ids: number[];
  documents: AgentDocument[];
  created_at: string;
  updated_at: string;
}

const BASE_URL = "/app/chats/agents";

// API functions
export const userAgentApi = {
  list: async (): Promise<Agent[]> => {
    const { data } = await axios.get(`${BASE_URL}.json`);
    return data;
  },
};

// Query keys
export const userAgentKeys = {
  all: ["userAgents"] as const,
};

// Hooks
export function useUserAgents() {
  return useQuery({
    queryKey: userAgentKeys.all,
    queryFn: userAgentApi.list,
  });
}
